/**
 * @file: description
 * @author:
 * @Date: 2020-03-02 11:52:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-06-11 16:57:09
 */
import { TabsMap } from '@src/types';

export const ADMIN_ARTICLE_LIST = 'artList';
export const ADMIN_GROUP_LIST = 'groupList';
export const ADMIN_MALL_LIST = 'mallList';
export const ADMIN_ORDER_LIST = 'orderList';
export const ADMIN_BANNER_LIST = 'bannerList';
export const ADMIN_THEMATIC_LIST = 'thematicList';

export const BANNER_TAB_ARTICLE = '1';
export const BANNER_TAB_ASK = '2';
export const BANNER_MAP = {
  defaultActiveKey: BANNER_TAB_ARTICLE,
  data: [
    {
      name: '文章banner',
      key: BANNER_TAB_ARTICLE
    },
    {
      name: '问答banner',
      key: BANNER_TAB_ASK
    }
  ]
};
export const MALL_MAP = {
  defaultActiveKey: ADMIN_MALL_LIST,
  data: [
    {
      name: '商城管理',
      key: ADMIN_MALL_LIST
    },
    {
      name: '订单管理',
      key: ADMIN_ORDER_LIST
    }
  ]
};

export const ADMIN_MAP: TabsMap = {
  defaultActiveKey: ADMIN_ARTICLE_LIST,
  data: [
    {
      title: '文章管理',
      index: ADMIN_ARTICLE_LIST
    },
    {
      title: '圈子管理',
      index: ADMIN_GROUP_LIST
    },
    // {
    //   title: '商城管理',
    //   index: ADMIN_MALL_LIST
    // },
    {
      title: 'BANNER',
      index: ADMIN_BANNER_LIST
    },
    {
      title: '精选专题',
      index: ADMIN_THEMATIC_LIST
    }
  ]
};
